class PaginationAutoLoading {

    constructor(manager) {
        this._init(manager)
    }

    _init(manager) {
        this.el = document.querySelector('[data-auto-loading]')
        this.elActions = document.querySelectorAll('[data-auto-loading-action]')

        if (!this.el || this.elActions.length == 0) {
            return;
        }

        this.manager = manager
        this.elCurrentMin = document.querySelector('[data-auto-loading-current-min]')
        this.elCurrentMax = document.querySelector('[data-auto-loading-current-max]')
        this.elCurrentTotal = document.querySelector('[data-auto-loading-current-total]')

        this.view = this.el.dataset.autoLoading
        // this.max = this.elCurrentMax.innerText
        this.min = this.el.dataset.autoLoadingMin
        this.currMin = this.elCurrentMin.innerText
        this.total = this.elCurrentTotal.innerText

        this.promise = null
        const mParams = this.getParams(false)
        this.elActions.forEach(el => {
            el.loading = el.querySelector('[data-loading]')

            if (el.dataset.autoLoadingAction == "auto") {
                this.elAction = el
            }

            let delta = 1
            if (el.dataset.autoLoadingAction == "prev") {
                delta = -1
            }

            el.delta = delta
            el.addEventListener('click', () => {
                if (!this.promise) {
                    this.promise = this.loadMore(el, delta)
                }
            })

            this.updateButton(el, mParams)
        });

        this.update()
        // window.addEventListener('popstate', () => this.onPopState())
        this.onScroll()

        if (true && this.elAction) {
            window.addEventListener('scroll', () => {
                if (!this.manager.promise) {
                    this.onScroll()
                }
            })
        }
    }

    loadMore(elAction) {
        if ((this.elCurrentMax.innerText == this.total && elAction.delta == 1) ||
            (this.elCurrentMin.innerText <= 1 && elAction.delta == -1)) {
            return
        }

        let mParams = this.getParams(elAction)
        this.setButtonLoading(elAction, true)

        const searchParams = new URLSearchParams(window.location.search)
        searchParams.append('view', this.manager.view)
        searchParams.append('page', this.manager.page)
        searchParams.append('type', 'partial')
        var baseUrl = window.location.href.replace(window.location.search, '')
        return fetch(baseUrl + '?' + searchParams.toString())
            .then((data) => data.text())
            .then((data) => {
                if (this.promise) {
                    if (elAction.delta == 1) {
                        this.el.innerHTML += data
                    } else {
                        this.el.innerHTML = data + this.el.innerHTML
                    }
                    this.updateButton(elAction, mParams)
                }
            })
            .finally(() => {
                this.promise = null
                this.setButtonLoading(elAction, false)
            })
    }

    setButtonLoading(elAction, bool) {
        if (bool) {
            elAction.loading.classList.add('lds-spinner--active')
            elAction.disabled = true
        } else {
            elAction.loading.classList.remove('lds-spinner--active')
            elAction.disabled = false
        }
    }

    setButtons(on) {
        this.elActions.forEach(el => {
            this.setButtonLoading(el, !on)
        })
    }

    getParams(elAction = null) {
        // let mParams = this.manager.params
        // const page = mParams.has('page') ? mParams.get('page') : 0
        // const view = mParams.has('view') ? mParams.get('view') : this.view
        // if (mParams.has('page')) {
        //     mParams.set('page', parseInt(page) + (elAction ? elAction.delta : 0))
        // } else {
        //     mParams.set('page', 1)
        // }
        // mParams.set('view', view)
        // this.manager.params = mParams
        // this.manager.updateURL(true)
        // console.log(mParams)
        // return mParams
        this.manager.page = this.manager.page + (elAction ? elAction.delta : 0)
        return {
            page: this.manager.page,
            view: this.manager.view
        }
    }

    isElementInViewport(el) {
        if (!el) {
            return false
        }
        var rect = el.getBoundingClientRect();
        return (
            rect.top > 0 &&
            rect.left > 0 &&
            rect.bottom < (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right < (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    }

    updateButton(elAction, mParams) {
        if (elAction.delta == 1) {
            const newCurrent = Math.min(this.view * this.manager.page, this.total)
            this.elCurrentMax.innerText = newCurrent
            if (newCurrent >= this.elCurrentTotal.innerText) {
                elAction.classList.add('button1--hidden')
                    // elAction.parentElement.removeChild(elAction)
                elAction.disabled = true;
            } else {
                elAction.classList.remove('button1--hidden')
                elAction.disabled = false;
            }
        } else {
            const newCurrent = Math.max(this.view * (this.manager.page - 1), this.min)
            this.elCurrentMin.innerText = newCurrent
            if (newCurrent <= 1) {
                elAction.classList.add('button1--hidden')
                    // elAction.parentElement.removeChild(elAction)
                elAction.disabled = true;
            } else {
                elAction.classList.remove('button1--hidden')
                elAction.disabled = false;
            }
        }
    }

    update() {
        this.promise = null
        this.elActions.forEach(el => {
            this.setButtonLoading(el, true)
        })

        return this.fetchData()
            .then(data => {
                this.min = data['min']
                this.currMin = data['currMin']
                this.total = data['total']
                this.elCurrentTotal.innerText = data['total']
                // this.elCurrentMax.innerText = data['max']
                const mParams = this.getParams(false)
                this.elActions.forEach(el => {
                    this.setButtonLoading(el, false)
                    this.updateButton(el, mParams)
                })
                this.elCurrentMin.innerText = data['currMin']
            }) // JSON-string from `response.json()` call
            .catch(error => {
                console.logError(error)
            })
    }

    fetchData() {
        let l = window.location
        const url = l.protocol + "//" + l.host + l.pathname + 'info' + l.search
        return fetch(url, {
            method: 'POST'
        }).then(response => {
            return response.json()
        })
    }

    onScroll() {
        if (this.isElementInViewport(this.elAction)) {
            if (!this.promise && !this.manager.promise && !this.elAction.disabled) {
                this.promise = this.loadMore(this.elAction, 1)
            }
        }
    }
}

export default PaginationAutoLoading
